// utils/parseDate.js
// BE sends timestamps like "2026-09-20T10:35:50.000000Z" — 6 digits of fractional seconds
// (microseconds, Laravel's default format). The ISO 8601 spec, and some browsers' Date parsers,
// only reliably support 3-digit milliseconds; a stricter engine can silently produce an
// Invalid Date (whose .getTime() is NaN) for the 6-digit form, which then makes any
// `NaN <= x` / `x <= NaN` comparison always false — e.g. a tournament that has clearly already
// started would still evaluate as "not started" everywhere that used the raw string directly.
// Truncating to 3 digits before parsing sidesteps the ambiguity regardless of which browser
// engine is actually affected.
export function parseDate(iso) {
    if (!iso) return null
    const normalized = iso.replace(/(\.\d{3})\d+(Z|[+-]\d{2}:?\d{2})?$/, '$1$2')
    return new Date(normalized)
}